import type { SagaIterator } from 'redux-saga';
import { takeLeading } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';
import type { BaseResource } from '../core/resourceStoreTypes';
import * as actions from './ssoActions';

const mkSSOResourceConfig = resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<BaseResource>();

export function* getSSOTokenActionWatcher(): SagaIterator {
  const config = mkSSOResourceConfig({
    resourceName: 'unregisterMeForBeta',
    resourceBaseUrl: '/jwt-sso/token-redirect',
    successAction: actions.getSSOTokenSuccess,
    failureAction: actions.getSSOTokenFailure,
  });
  yield takeLeading(actions.getSSOToken, resourceSagaUtils.qcsSyncGetResource<BaseResource>, config);
}

export default [getSSOTokenActionWatcher];
